<template>
  <v-app id="inspire">
    <v-main>      
      <router-view></router-view>
      <v-container>
        <v-card flat class="mt-5">
          <v-row>
            <v-col>
              <p class="font-weight-light caption text-center ma-0">restaurantmaestro.mx</p>
              <p class="font-weight-light caption text-center ma-0">contacto@restaurantmaestro.mx</p>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
      
      <br />
      <br />
      <br />
    </v-main>
    <v-footer padless tile fixed>
      <v-toolbar dense>
        <v-tabs dark background-color="primary" grow>
          <v-tab @click="irAlInicio()">
            <v-icon>mdi-home</v-icon>
          </v-tab>

          <v-tab @click="IrABuscarProductos()">
            <v-icon>mdi-magnify</v-icon>
          </v-tab>

          <v-tab @click="irACarrito()" v-if="numeroProductosCarrito > 0">
            <v-badge color="red" overlap :content="numeroProductosCarrito">
              <v-icon>mdi-cart-outline</v-icon>
            </v-badge>
          </v-tab>

          <v-tab @click="irAOpcionesCuentaUsuario()" v-if="haIniciadoSesion" >
            <v-icon>mdi-account</v-icon>
          </v-tab>
          <v-tab v-else @click="irAlLogin()">
            <v-icon>mdi-account</v-icon>
          </v-tab>
        </v-tabs>
      </v-toolbar>
    </v-footer>

    <v-snackbar v-model="muestraMensajeGlobal" color="info" top>
      {{ elMensajeGlobal }}
    </v-snackbar>
  </v-app>
</template>

<script>
import Vuex from "vuex";
import RMSMDLocal from "@/services/local.service.js";
import RMSMD from "@/services/user.public.service.js";

export default {
  props: {
    source: String,
  },
  components: {
    //Translator
  },
  computed: {
    ...Vuex.mapState([
      "numeroProductosCarrito",
      "haIniciadoSesion",
      "muestraMensajeGlobal",
      "elMensajeGlobal",
    ]),
    claveInstancia: function () {
      var ci = this.$route.params.claveInstancia;
      if (!ci) {
        ci = sessionStorage.claveInstancia;
      }
      return ci;
    },
  },
  data: () => ({
    idiomas: [
      {
        code: "en",
        name: "English",
        cname: "英语",
        ename: "English",
      },
      {
        code: "fr",
        name: "Français",
        cname: "法语",
        ename: "French",
      },
      {
        code: "es",
        name: "Español",
        flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/il.svg",
        cname: "西班牙语",
        ename: "Español",
      },
    ],
    versionUI: 102,
    drawer: false,
    errored: false,
    loading: false,
    mensajeError: "",
  }),
  methods: {
    ...Vuex.mapMutations([
      "establecerNumeroProductos",
      "establecerHaIniciadoSesion",
      "enviarMensajeGlobal",
    ]),
    irAlLogin() {
      this.$router.push({
        name: "login",
        params: {
          claveInstancia: this.claveInstancia,
          regresa: "home",
        },
      });
    },
    IrABuscarProductos() {
      this.$vuetify.goTo(0);
      this.$router.push({
        name: "busqueda",
        params: {
          claveInstancia: this.claveInstancia,
        },
      });
    },
    irAOpcionesCuentaUsuario() {
      this.$router.push({
        name: "cuentausuario",
      });
    },
    logOut() {
      this.dialogCerrarSesion = false;
      sessionStorage.removeItem("jwt");
      this.establecerHaIniciadoSesion(false);
      this.enviarMensajeGlobal("La sesión se ha cerrado correctamente");
    },
    irAlInicio() {
      this.$router.push({
        name: "menus",
        params: { claveInstancia: this.claveInstancia },
      });
    },
    
    irACarrito() {     
      //return; 
      this.$router.push({
        name: "carrito",
        params: {
          claveInstancia: this.claveInstancia,
        },
      });
    },
  },
  mounted() {
    var verGuardada = localStorage.getItem("VersionUI");
    if (verGuardada === null) localStorage.setItem("VersionUI", this.versionUI);
    else if (verGuardada < this.versionUI) {
      localStorage.setItem("VersionUI", this.versionUI);
      this.$router.go(0);
    }
    var jwt = sessionStorage.getItem("jwt");
    this.establecerHaIniciadoSesion(jwt !== null);
    this.establecerNumeroProductos(RMSMDLocal.getCuentaProductosLista());
    /* var configuracion = sessionStorage.getItem("configSuscriptor");
    if (configuracion !== null) {
      console.log();
    } */
  },
};
</script>
